import { styled } from '@mui/material/styles';

export const LiveSearchListItem = styled('li')`
  border-bottom: 1px solid lightgray;
`;
